import bem from 'utils/bem';

export const block = bem('linkedin-autopost-modal');
